// BCM-898 · Goods Receipt Dashboard — 4-second success toast (slides 10, 17, 30).
// Every success on this dashboard is a toast that auto-dismisses after 4s and can
// be closed early. Failures keep their existing surfaces (e.g. GRN blocking popup).
//
// Defaults (white card, bottom-center) are UNCHANGED for every existing caller.
// Optional props exist only for the top-right banner variant — PA8's MARD Data
// Updated confirmation (slide 26/28 mockup) and Sync PO/Sync Inventory's
// success AND failure outcomes (SyncActions.jsx, replacing the old result-
// dialog popup for those):
//   anchorOrigin — overrides the Snackbar position.
//   banner       — renders the solid-color banner variant instead of the card.
//   success      — banner only; false renders it red with an error icon
//                  instead of green with a check (default true).
import React, { useEffect } from "react";
import { Snackbar, Paper, Typography, IconButton, Box } from "@material-ui/core";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import ErrorIcon from "@material-ui/icons/Error";
import CloseIcon from "@material-ui/icons/Close";
import { TOAST_MS } from "../../utils/constants";

const SuccessToast = ({ open, message, onClose, autoHideDuration = TOAST_MS, anchorOrigin, banner, success = true }) => {
  useEffect(() => {
    if (!open) return undefined;
    const t = setTimeout(() => onClose && onClose(), autoHideDuration);
    return () => clearTimeout(t);
  }, [open, autoHideDuration, onClose]);

  if (!open) return null;
  return (
    <Snackbar
      open={open}
      anchorOrigin={anchorOrigin || { vertical: "bottom", horizontal: "center" }}
    >
      {banner ? (
        <Box
          display="flex"
          alignItems="center"
          style={{ gap: 10, backgroundColor: success ? "#2e7d32" : "#c62828", color: "#fff", padding: "12px 16px", borderRadius: 6, maxWidth: 420 }}
        >
          {success ? <CheckCircleIcon style={{ color: "#fff" }} /> : <ErrorIcon style={{ color: "#fff" }} />}
          <Typography style={{ fontWeight: 500, fontSize: "0.85rem", color: "#fff" }}>{message}</Typography>
          <IconButton size="small" onClick={onClose} aria-label="close" style={{ color: "#fff" }}>
            <CloseIcon fontSize="small" />
          </IconButton>
        </Box>
      ) : (
        <Paper elevation={4} style={{ padding: "12px 18px", borderRadius: 8 }}>
          <Box display="flex" alignItems="center" style={{ gap: 10 }}>
            <CheckCircleIcon style={{ color: "#2e7d32" }} />
            <Typography style={{ fontWeight: 500 }}>{message}</Typography>
            <IconButton size="small" onClick={onClose} aria-label="close">
              <CloseIcon fontSize="small" />
            </IconButton>
          </Box>
        </Paper>
      )}
    </Snackbar>
  );
};

export default SuccessToast;
